import service from '../../config/axios.config';

export const fetchProjects = () =>
  service.get(`projects`);